/**
 * Minimal class-name joiner.
 *
 * Components take a `className` prop for layout tweaks from the outside; this
 * merges it with their own classes and drops anything falsy. A dependency for
 * this would not survive being asked about (CLAUDE.md, "Do not add a dependency
 * without a reason").
 */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
